import { Locales } from "./locales";

import en from "./en.json";
import fr from "./fr.json";
import de from "./de.json";
import es from "./es.json";

export const messages = {
  [Locales.en]: en,
  [Locales.fr]: fr,
  [Locales.de]: de,
  [Locales.es]: es
};

export const defaultLocale = Locales.en;